import { IEnvironment } from './IEnvironment';

export const sharedEnv: IEnvironment = {
    baseApiUrl: 'https://platform-qa.controltower.tech/api',
    baseRealTimeUrl: 'https://platform-qa.controltower.tech',
    auth0: {
        domain: 'auth-qa.controltowerapp.com',
        authorizationParams: {
            audience: 'https://platform-qa.controltower.tech/api/',
        },
    },
    jwtConfig: {
        allowedList: [
            'platform-qa.controltower.tech',
            'radiusrecycling-qa.api.controltowerapp.com',
            'parts-qa.api.controltower.tech',
        ],
        disallowedList: [/\/one-time-links\/[a-f\d-]+\/authenticate/],
    },
    assetsSource:
        'https://pf-prod-public-files.controltower.tech/assets-branding/icons',
};
